import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import ImageZoom from "react-image-zooom";

const Main = () => {
  return (
    <main id="container-main" className="container">
      <div className="row-block">
        <h1>Downloader Manager/uGET</h1>
        <a name="top"></a>
        <p>
          uGet is an open source download manager application which supports
          many platforms. It is portable and can be downloaded for usage without
          installation. The instructions below describe how to use uGet to
          download files using URLs saved in a text or CSV file from{" "}
          <a
            href="https://apps.nationalmap.gov/downloader/"
            target="_blank"
            rel="noreferrer"
          >
            TNM Download
          </a>
          . Video tutorial available here:{" "}
          <a
            href="https://www.youtube.com/watch?v=QhN0Zuy1yKc"
            target="_blank"
            rel="noreferrer"
          >
            https://www.youtube.com/watch?v=QhN0Zuy1yKc
          </a>
        </p>
        <p>
          <FontAwesomeIcon
            icon={faCircleInfo}
            size="sm"
            style={{ color: "#00264c" }}
          />{" "}
          <span style={{ fontSize: 14 }}>
            USGS does not assume responsibility for usage or functionality of
            uGet software for downloading data. More information about uGet can
            be found on{" "}
            <a href="http://ugetdm.com/" target="_blank" rel="noreferrer">
              Home
            </a>
            ,{" "}
            <a
              href="http://ugetdm.com/features"
              target="_blank"
              rel="noreferrer"
            >
              Features
            </a>
            , and{" "}
            <a href="http://ugetdm.com/help" target="_blank" rel="noreferrer">
              Help
            </a>{" "}
            pages on the uGet website.
          </span>
        </p>
      </div>
      <div>
        <div className="col-md-12">
          <div className="card">
            <h2 className="card-header fs-6">Download and Setup - Windows</h2>
            <div className="card-body">
              <div className="card-text">
                <ul>
                  <li>
                    7-zip is required to unzip the .7z file you will download in
                    the third bullet below.
                    <ul id="7-zip-instructions">
                      <li className="fw-bold">Installation Instructions:</li>
                      <li>
                        Go to the{" "}
                        <a
                          href="http://www.7-zip.org/download.html"
                          target="_blank"
                          rel="noreferrer"
                        >
                          7-zip website
                        </a>
                      </li>
                      <li>
                        Download and install the 32-bit x86 .exe file or 64-bit
                        x64 .exe file depending on your operating systems.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Go to{" "}
                    <a
                      href="https://github.com/ugetdm/uget-windows-installer"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://github.com/ugetdm/uget-windows-installer
                    </a>{" "}
                    or{" "}
                    <a
                      href="https://sourceforge.net/projects/urlget/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://sourceforge.net/projects/urlget/
                    </a>
                    .
                  </li>
                  <li>
                    Download the package zip (.7z) file. Select "without
                    translation files" unless multi-language support is
                    necessary.
                  </li>
                  <li>
                    Unzip the downloaded .7z package file in a folder using
                    7-zip which you installed in the first bullet above.
                  </li>
                  <li>
                    Run the application by double-clicking \bin\uget.exe in the
                    installation folder.
                  </li>
                  <li>
                    Once the uGet program is installed, you can run it as many
                    times as you need to in the future. You do not need to
                    install it again.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card ">
            <h2 className="card-header fs-6">
              Instructions - using Text file as input
            </h2>
            <div className="card-body">
              <div className="card-text">
                <h3 className="fs-5">Preparing Input Text File</h3>
                <hr className="custom" />
                <p>
                  In the TNM Download application, download URLs can be saved in
                  a text file using one of the two methods described below:
                </p>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-4 col-xs-12">
                  <span className="fw-bold">Option #1</span>
                  <p>
                    After product search is completed, click “Save as Text” in
                    the Product view.
                  </p>
                </div>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/uget_text1_new.png"
                    alt="Products - Txt file"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-4 col-xs-12">
                  <span className="fw-bold">Option #2</span>
                  <p>
                    After product search is completed, select specific products
                    to add to the Cart, go to the Cart view, and click “Export
                    URLs to TXT” link.
                  </p>
                </div>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/uget_text2_new.png"
                    alt="Cart - TXT and CSV files"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <h3 className="fs-5">Downloading Files using uGet</h3>
                <hr className="custom" />
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Start uGet by clicking uget.exe. Select "File" in the menu.
                  Select "Batch Downloads" and "Text file import (.txt)"
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-text-import-large.png"
                    alt="File-Batch Downloads-Text file import (.txt)"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Select an input file. Click OK.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-file-selection-large.png"
                    alt="Selected file"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  All URLs are automatically imported. Click "Forward".
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-forward-large.png"
                    alt="Forward"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Select the output folder and "Runnable" for the Status. Click
                  OK.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-runnable-large.png"
                    alt="Status: Runnable"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  To check download status, click "All Status" to view the
                  status of all items. Three items are downloaded at a time.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-all-download-large.png"
                    alt="All Status"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Click "Active" to view only the items currently being
                  downloaded.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-active-download-large.png"
                    alt="Active"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-4">
                  <p>
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      size="sm"
                      style={{ color: "#00264c" }}
                    />{" "}
                    "Date modified" property of the download file shows the date
                    when the file was uploaded to the download site, instead of
                    the date of download.
                  </p>
                </div>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/downloaded-file-large.gif"
                    alt="Date modified = uploaded date"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
            </div>
            <div className="card-footer">
              <a href="#top">Back to Top</a>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card ">
            <h2 className="card-header fs-6">
              Instructions - using CSV file as input
            </h2>
            <div className="card-body">
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Open the CSV file saved from the TNM Download. Select and copy
                  all or some of download URLs.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-copy-large.png"
                    alt="Select-Copy"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Start uGet by clicking uget.exe. Select "File" in the menu.
                  Select "Batch Downloads" and "Clipboard batch…"
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-clipboard-large.png"
                    alt="File-Batch Downloads-Clipboard batch..."
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Copied URLs are automatically imported. Click "Forward".
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-clipboard-imported-large.png"
                    alt="Forward"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Select the output folder and "Runnable" for the Status. Click
                  OK.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-runnable-large.png"
                    alt="Status-Runnable"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  To check download status, click "All Status" to view the
                  status of all items. Three items are downloaded at a time.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-all-download-large.png"
                    alt="All Status"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <p className="col-md-4 col-sm-4">
                  Click "Active" to view only the items currently being
                  downloaded.
                </p>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/uget-active-download-large.png"
                    alt="Active"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-4">
                  <p>
                    <FontAwesomeIcon icon={faCircleInfo} /> "Date modified"
                    property of the download file shows the date when the file
                    was uploaded to the download site, instead of the date of
                    download.
                  </p>
                </div>
                <figure className="col-md-8 col-sm-8 img-div">
                  <ImageZoom
                    src="img/large/downloaded-file-large.gif"
                    alt="Date modified = date uploaded"
                    className="img-responsive"
                    zoom="175"
                  />
                </figure>
              </div>
            </div>
            <div className="card-footer">
              <a href="#top">Back to Top</a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default Main;
